// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2bid4","text":"SelectPayment_text__763_B","title":"SelectPayment_title__3sIce","btn":"SelectPayment_btn__2PeXh"};